module.exports = __webpack_public_path__ + "static/pic01-1bcbe6b66d30a129d0e0a14af24c57e1.png";